import React from 'react'

/* doc
---
title: ModalCardFoot
name: ModalCardFoot
category: React - Bulma
---

A `ModalCardFoot` component based on Bulma `.modal-card-foot`. The footer in ModalCard

This should be used with `ModalCard`

See [Bulma Documentation](http://bulma.io/documentation/components/modal/) for reference and full options.

```html_example
  <Modal>
    <ModalBackground />
    <ModalCard>
      <ModalCardHead>
        <ModalCardTitle>
          ...
        </ModalCardTitle>
      </ModalCardHead>
      <ModalCardBody>
        ...
      </ModalCardBody>
      <ModalCardFoot>
        ...
      </ModalCardFoot>
    </ModalCard>
  </Modal>
```
*/
function ModalCardFoot(props) {
  const { className, children, ...rest } = props

  const classes = [
    'bulma-modal-card-foot',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default ModalCardFoot
